module.exports = __webpack_public_path__ + "img/xinyong.e6dc7366.jpg";